module.exports = __webpack_public_path__ + "static/media/cover.9efe2b45.jpg";